export enum E_Referrer {
  ORGANIC = "organic", // This is the default value
  PATIENT_ACTION_LINK = "patient_action_link",
  MERGE_TAG = "merge_tag",
  PORTAL_IN_PRACTICE = "portal_in_practice",
  APPOINTMENT_RECALL = "appointment-recall",
  TASK_REMINDER = "task-reminder",
  RESERVE_WITH_GOOGLE = "reserve-with-google",
  UNKNOWN = "unknown",
}

export const VALID_REFERRERS = Object.values(E_Referrer) as string[];
